import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { api } from "../../services/apiService";

/**
  Dados da linha do operador quando o usuário é Operador e tem vínculo em OperadorLinha.
  Re-busca ao mudar de rota para capturar mudanças de vínculo sem precisar recarregar a página.
 */
export function useMinhaLinhaOperador(userInfo) {
  const isOperador = userInfo?.roleNome === "Operador";
  const [linhaInfo, setLinhaInfo] = useState({ numeroLinha: null, idLinha: null });
  const [loading, setLoading] = useState(isOperador);
  const location = useLocation();

  useEffect(() => {
    if (!userInfo?.id || userInfo?.roleNome !== "Operador") {
      setLinhaInfo({ numeroLinha: null, idLinha: null });
      setLoading(false);
      return;
    }

    setLoading(true);
    let cancelled = false;

    (async () => {
      try {
        const res = await api.operadorLinha.obterDadosLinha();
        const payload = res?.data ?? res;
        if (cancelled) return;
        if (payload?.temVinculo && payload?.numeroLinha != null) {
          setLinhaInfo({ numeroLinha: payload.numeroLinha, idLinha: payload.idLinha ?? null });
        } else {
          setLinhaInfo({ numeroLinha: null, idLinha: null });
        }
      } catch {
        if (!cancelled) setLinhaInfo({ numeroLinha: null, idLinha: null });
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [userInfo?.id, userInfo?.roleNome, location.pathname]);

  return { ...linhaInfo, loading };
}
